// 用户状态管理（简化版，无登录功能）

const state = {
  // 项目无登录功能，保留用户状态结构以便扩展
  currentUser: {
    name: '管理员',
    role: 'admin'
  }
}

const mutations = {
  // 设置当前用户信息
  SET_CURRENT_USER: (state, userInfo) => {
    state.currentUser = userInfo
  }
}

const actions = {
  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit('SET_CURRENT_USER', userInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}